import ExcelJS from "exceljs";
import ExportMenu from "../../../../Common/ExportMenu/ExportMenu";
// import { useMonthWiseAttendanceStore } from "../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceStore";
// import { formattedDate } from "./../../../Common/helper/helpar";

export const FrequencyBinsExport = ({ data, days }) => {


    // console.log("Attendance", Attendance);
    //   const downloadAsExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet("Month-wise Attendance");

    //     // Define styles
    //     const boldFont = { bold: true };

    //     // Get current date and time
    //     const currentDate = new Date();
    //     const formattedDate = `${currentDate.getDate()}-${
    //       currentDate.getMonth() + 1
    //     }-${currentDate.getFullYear()}`;
    //     const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    //     const downloadDateTime = `Month-wise Attendance Report Generated on: ${formattedDate}, ${formattedTime}`;

    //     // Add the downloadDateTime to the worksheet
    //     worksheet.addRow(["", "", downloadDateTime, ""]);
    //     worksheet.mergeCells(1, 2, 1, 12);
    //     worksheet.getCell(1, 2).value = downloadDateTime;
    //     worksheet.getCell(1, 2).font = boldFont;
    //     worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    //     // Add report title
    //     worksheet.addRow(["", "", "Month-wise Attendance Report", ""]);
    //     worksheet.mergeCells(2, 2, 2, 12);
    //     worksheet.getCell(2, 2).value = "Month-wise Attendance Report";
    //     worksheet.getCell(2, 2).font = boldFont;
    //     worksheet.getCell(2, 12).alignment = { horizontal: "center" };

    //     // Define table headers
    //     const tableHeaderRow = worksheet.addRow([
    //       "S.No",
    //       "Date",
    //       "TS/SCTP",
    //       "SAT Trips",
    //       "Secondary",
    //       "Others",
    //       "Estimated Tonnage",
    //       "HKL",
    //       "RCV",
    //       "PVT Tech",
    //       "Est MT",
    //       "Actual MT",
    //       "Variance",
    //     ]);

    //     tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    //       cell.font = boldFont;
    //       cell.alignment = { horizontal: "left", wrapText: true, vertical: "middle" };
    //       if (colNumber >= 1 && colNumber <= 45) {
    //         cell.fill = {
    //           type: "pattern",
    //           pattern: "solid",
    //           fgColor: { argb: "F6B1B1" },
    //           bgColor: { argb: "FFFFFFFF" },
    //         };
    //       }
    //     });

    //     // Add data rows
    //     let totalDeviationDistance = 0; // Variable to track total deviation distance

    //     data.forEach((item, index) => {
    //       const deviationDistance = item.deviationDistance
    //         ? (item.deviationDistance / 1000).toFixed(2)
    //         : 0; // Convert to km
    //       totalDeviationDistance += deviationDistance;

    //       worksheet
    //         .addRow([
    //           index + 1,
    //           item.employeeId,
    //           item.name,
    //           item.operation,
    //           item.designation,
    //           item.transferStationName,
    //           item.punchInLocation,
    //           ...Attendance[index],
    //           item.presentDays,
    //           item.absentDays,
    //           item.forcedAttendanceDays,
    //         ])
    //         .eachCell({ includeEmpty: true }, (cell) => {
    //           cell.alignment = { horizontal: "left" };
    //         });
    //     });

    //     // Set column widths dynamically
    //     worksheet.columns = [
    //       { width: 5 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //       { width: 20 },
    //     ];

    //     // Save the workbook to a file
    //     try {
    //       const buffer = await workbook.xlsx.writeBuffer();
    //       const blob = new Blob([buffer], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //       });
    //       const url = URL.createObjectURL(blob);
    //       const a = document.createElement("a");
    //       a.href = url;
    //       a.download = "Month-wiseAttendanceReport.xlsx";
    //       a.click();
    //       URL.revokeObjectURL(url);
    //     } catch (error) {
    //       console.error("Error generating Excel file:", error);
    //     }
    //   };

    return (
        <>
            <ExportMenu
              items={[
                { label: "PDF", icon: "fa-solid fa-file-pdf" },
                { label: "Excel", icon: "fa-solid fa-file-excel" },
              ]}
            />
        </>
    );
};
